"use client";

import { useEffect, useRef, useState } from 'react';

/**
 * This hook will return true if the isLoading prop is true, and the duration has passed from
 * when the isLoading props was set to true. This is useful to prevent the loading state from
 * flickering when the loading state is set to true for a very short duration.
 *
 * @example
 * const isLoading = useMinLoadingState(isLoadingProp, 750);
 */

export function useMinLoadingState(isLoading: boolean, duration: number) {
  const [minLoadingState, setMinLoadingState] = useState(false);

  const timerRef = useRef(null);

  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current);
    };
  }, []);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isLoading) {
      clearTimeout(timerRef.current);
      setMinLoadingState(true);
      timerRef.current = setTimeout(() => {
        setMinLoadingState(false);
      }, duration);
    }
  }, [isLoading, duration]);

  return minLoadingState || isLoading;
}
